import { TabPanel } from "@mui/lab";
import { InputDate } from "../../../../../shared/components/InputDate";
import { InputSelect } from "../../../../../shared/components/InputSelect";
import { InputMoney } from "../../../../../shared/components/InputMoney";
import { Button } from '../../../../../shared/components/button/Button';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import Box from '@mui/material/Box';
import DataTable from "../../../../../shared/components/Table";
import { GridColDef } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { StatusActions } from "./StatusActions";
import { useEffect, useMemo, useState } from "react";
import { MaquinaRequest } from "../../../../../controllers/Types";
import ProdutoController from "../../../../../controllers/ProdutoController";
import * as Icon from '@mui/icons-material/';
import { MaquinaCadastrar } from "../../../../../routes/RoutesNames";


const OPTIONS_RECORRENCIA = [
    {
        value: 'Personalizada',
        label: 'Personalizada',
    },
    {
        value: 'Mensal',
        label: 'Mensal',
    }
];

const COLUMNS: GridColDef[] = [
    {
        field: 'marca',
        headerName: 'Marca',
        headerAlign: 'left',
        align: 'left',
        width: 200,
        valueGetter: (value: any) => value,
    },
    {
        field: 'modelo',
        headerName: 'Modelo',
        headerAlign: 'left',
        align: 'left',
        valueGetter: (value: any) => value,
    },
    {
        field: 'numeroSerie',
        headerName: 'Nº de Série',
        headerAlign: 'left',
        align: 'left',
        valueGetter: (value: any) => value,
    }
];

interface TabLocacaoProps {
    values: any;
    handleChange: any;
    handleBlur: any;
    touched: any;
    errors: any;
    duploClick?: boolean;
    handleDeleteMachine: (product: any) => void;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export interface TabLocacaoMachineOptions {
    idItem?: string | null;
    produto?: string | null;
    quantidade?: string | null;
    prod_marca?: string | null;
    prod_modelo?: string | null;
    prod_numSerie?: string | null;
    id?: string | null;
    label?: string | null;
}

export const TabLocacao = ({
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    duploClick,
    setFieldValue,
    handleDeleteMachine,
}: TabLocacaoProps) => {

    const [maquinas, setMaquinas] = useState<TabLocacaoMachineOptions[]>([]);
    const [searchText, setSearchText] = useState('');
    const [maquina, setMaquina] = useState<TabLocacaoMachineOptions | null>(null);
    const [inputValue, setInputValue] = useState('');
    const [errorProduto, setErrorProduto] = useState(false);

    /**
     * A busca de máquina respondeu com sucesso?
     *
     * [CORRIGIDO 21/08/2026] Antes esta flag era "mostrar o botão Criar", ligada com
     * `response.Data.length === 0`. Aquele contador NUNCA é zero: o front manda
     * `{ prod_descricao }` e o C# espera `{ Descricao }`, então nenhum filtro chega à
     * PROC_MAQUINA_LISTAR e ela devolve TODAS as máquinas. Quem filtra é o MUI, aqui no
     * navegador - por isso a busca parece funcionar, e por isso o "NO OPTIONS" aparecia
     * com a API tendo devolvido dezenas de linhas. O botão nunca aparecia.
     *
     * Agora esta flag guarda só o que ela pode saber: se a chamada deu 200. Quem decide
     * mostrar o botão é `mostrarCriarMaquina`, mais abaixo, olhando a MESMA lista
     * filtrada que o usuário está vendo.
     */
    const [buscaRespondeu, setBuscaRespondeu] = useState(false);


    const handleInputChange = (_event: any, newInputValue: any) => {
        setInputValue(newInputValue);
        setSearchText(newInputValue);
    };

    useEffect(() => {
        if (values?.locacao?.recorrencia === 'Mensal' && values?.locacao?.dataInicio) {
            const dataInicio = new Date(values.locacao.dataInicio);

            if (!isNaN(dataInicio.getTime())) {
                const novaDataFinal = new Date(dataInicio);
                novaDataFinal.setMonth(novaDataFinal.getMonth() + 1);
                const dataFormatada = novaDataFinal.toISOString().split('T')[0];

                setFieldValue('locacao.dataFim', dataFormatada);
            }
        }
    }, [values?.locacao?.recorrencia, values?.locacao?.dataInicio, setFieldValue]);

    useEffect(() => {
        const fetchMaquinas = async () => {
            // `Descricao` e nao `prod_descricao`: e o nome que o ProdutoRequest do C#
            // desserializa. Com o nome errado o filtro nao chegava na proc e vinha a
            // tabela inteira em cada tecla.
            const request: MaquinaRequest = {
                Descricao: searchText,
            };
            const response = await ProdutoController.ListarMaquina(request);
            // console.log(response.Data)
            if (response.StatusCode === 200) {
                setMaquinas(
                    response.Data.map((item: any) => ({
                        id: item.prod_id,
                        label: item.prod_descricao,
                        ...item,
                    }))
                );
                setBuscaRespondeu(true);
            } else {
                // Chamada FALHOU. Diferente de "não existe": a máquina pode existir e a
                // consulta ter caído. Oferecer "Criar" aqui empurraria o usuário a cadastrar
                // uma duplicata por causa de um erro de rede.
                setMaquinas([]);
                setBuscaRespondeu(false);
            }
        };


        if (inputValue.length >= 1) {
            fetchMaquinas();
        } else {
            setMaquinas([]);
            setBuscaRespondeu(false);
        }
    }, [inputValue, searchText, maquina?.id]);

    /**
     * A MESMA lista que o dropdown mostra.
     *
     * Existe para o botão e o dropdown não poderem discordar: o `filterOptions` do
     * Autocomplete recebe exatamente este array, então "o usuário não vê nenhuma opção"
     * e "o botão Criar aparece" passam a ser a mesma condição, por construção - e não
     * duas contas parecidas que um dia divergem. Foi justamente a divergência entre elas
     * que fez o botão nunca aparecer.
     *
     * createFilterOptions() é o filtro padrão do MUI, o mesmo que estava agindo antes.
     * Ele ignora acento, então digitar "CAFE" continua achando "CAFÉ".
     */
    const filtrarMaquinas = useMemo(() => createFilterOptions<TabLocacaoMachineOptions>(), []);

    const maquinasFiltradas = useMemo(
        () => filtrarMaquinas(maquinas, {
            inputValue,
            getOptionLabel: (opcao: any) => opcao?.label ?? '',
        }),
        [filtrarMaquinas, maquinas, inputValue]
    );

    /**
     * Oferece criar quando: o usuário digitou algo, a busca respondeu, e o que ele está
     * vendo é lista vazia. Sem o `buscaRespondeu` o botão apareceria durante uma falha de
     * rede, empurrando o cadastro de uma duplicata.
     */
    const mostrarCriarMaquina =
        inputValue.trim().length >= 1 && buscaRespondeu && maquinasFiltradas.length === 0;

    const actionColumn: GridColDef = {
        field: 'status',
        headerName: '',
        width: 5,
        renderCell: (params) => (
            <StatusActions params={params} handleDelete={handleDeleteMachine} />
        ),
    };

    const handleAdicionar = async () => {

        if (maquina) {

            const response = await ProdutoController.ListarMaquinaLocacao(Number(maquina.id));
            //Se retornar 200, significa que a máquina já está locada
            if (response.StatusCode === 200) {
                toast.warning("Esta máquina ja está locada.");
                return;
            }

            if (!maquina) {
                setErrorProduto(true);
                toast.warning("Selecione uma máquina para adicionar.");
                return;
            }

            setErrorProduto(false);

            const newItem = {
                marca: maquina.prod_marca ?? '',
                modelo: maquina.prod_modelo ?? '',
                numeroSerie: maquina.prod_numSerie ?? '',
                prod_id: maquina.id,
            };

            const currentList = values.locacao.locacao_list || [];

            // Compara por prod_id (a chave que a gravacao usa), com fallback no numero de serie
            // normalizado como texto: comparar so a serie com === falhava quando o item carregado
            // do banco vinha como numero e o selecionado como string, duplicando a maquina.
            const serie = (v: any) => String(v ?? '').trim();
            const itemExists = values.locacao.locacao_list?.some((item: any) =>
                Number(item.prod_id) === Number(maquina.id) ||
                (serie(item.numeroSerie) !== '' && serie(item.numeroSerie) === serie(maquina.prod_numSerie))
            );

            if (itemExists) {
                toast.warning("Máquina já adicionada na lista.");
                return;
            }

            setFieldValue('locacao.locacao_list', [...currentList, newItem]);

            setMaquina(null);
            setInputValue('');
            setSearchText('');
            setFieldValue('value', '');
        }
    };

    return (
        <TabPanel value={'4'}>
            <div className={'grid grid-cols-12 pt-4 gap-4 w-5/6'}>
                <InputSelect
                    label='Recorrência'
                    name='locacao.recorrencia'
                    size='small'
                    items={OPTIONS_RECORRENCIA}
                    className={'col-span-2'}
                    value={values?.locacao?.recorrencia}
                    handleChange={handleChange}
                    helperText={
                        touched?.locacao?.recorrencia && errors?.locacao?.recorrencia
                            ? errors?.locacao?.recorrencia
                            : ''
                    }
                    error={
                        !!(
                            touched?.locacao?.recorrencia && errors?.locacao?.recorrencia
                        )
                    }
                    disabled={duploClick}
                />
                <InputDate
                    label="Data Início"
                    name="locacao.dataInicio"
                    className={'col-span-2'}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    disabled={duploClick}
                    error={
                        touched?.locacao?.dataInicio &&
                            errors?.locacao?.dataInicio
                            ? errors?.locacao?.dataInicio
                            : ''
                    }
                    hasError={
                        !!(
                            touched?.locacao?.dataInicio &&
                            errors?.locacao?.dataInicio
                        )
                    }
                    value={values?.locacao?.dataInicio ?? ''}
                />
                <InputDate
                    label="Data Fim"
                    name="locacao.dataFim"
                    className={'col-span-2'}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    disabled={duploClick || values?.locacao?.recorrencia === 'Mensal'}
                    error={
                        touched?.locacao?.dataFim &&
                            errors?.locacao?.dataFim
                            ? errors?.locacao?.dataFim
                            : ''
                    }
                    hasError={
                        !!(
                            touched?.locacao?.dataFim &&
                            errors?.locacao?.dataFim
                        )
                    }
                    value={values?.locacao?.dataFim ?? ''}
                />
                <Autocomplete
                    options={maquinas}
                    // Recebe a lista JA filtrada acima, para o dropdown e o botao Criar
                    // nunca discordarem sobre "nao achou nada".
                    filterOptions={() => maquinasFiltradas}
                    getOptionLabel={(option) => option?.label || ''}
                    value={maquina}
                    size='small'
                    onChange={(_, newValue) => setMaquina(newValue)}
                    inputValue={inputValue}
                    sx={{ width: '100%', gridColumn: 'span 4 / span 4' }}
                    onInputChange={handleInputChange}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                            {option.label}
                        </li>
                    )}
                    clearOnBlur={false}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label='Máquina'
                            error={errorProduto}
                            helperText={errorProduto ? 'Selecione uma máquina' : ''}
                        />
                    )}
                />

                <InputMoney
                    label={'Valor'}
                    className={'col-span-2'}
                    name={'locacao.valor'}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    error={touched?.locacao?.valor && errors?.locacao?.valor ? errors?.locacao?.valor : ''}
                    hasError={!!(touched?.locacao?.valor && errors?.locacao?.valor)}
                    value={values?.locacao?.valor ?? ''}
                />
            </div>

            <Box className={'flex flex-row space-x-4 pb-4 mt-4'}>
                <Button
                    title={'Adicionar'}
                    variant={'primary'}
                    onClick={() => { handleAdicionar(); }}
                    disabled={duploClick}
                />

                {/*
                  [NOVO 21/08/2026] Atalho para cadastrar a máquina sem abandonar o pedido.
                  Abre em OUTRA GUIA de propósito: assim esta guia não é desmontada e nada do
                  que já foi preenchido se perde - era esse o problema relatado, o usuário
                  tinha de recomeçar o pedido do zero.
                  Depois de salvar e fechar a outra guia, basta pesquisar de novo aqui: a
                  busca vai na API na hora e acha a máquina nova. Não há estado a sincronizar
                  entre as guias.
                  Mesmo padrão de produto e serviço (ModalProductSelect / ModalServiceSelect).
                */}
                {mostrarCriarMaquina && (
                    <a href={MaquinaCadastrar} target="_blank" rel="noopener noreferrer">
                        <Button
                            title="Criar"
                            variant="secondary"
                            iconStart={<Icon.Create />}
                        />
                    </a>
                )}
            </Box>

            <div className={'grid grid-cols-8 gap-7'}>
                <Box className='col-span-8'>
                    <DataTable
                        height={'48vh'}
                        columns={[...COLUMNS, ...[actionColumn]]}
                        rows={values?.locacao?.locacao_list?.map((item: any, index: number) => {
                            return {
                                id: index,
                                ...item,
                            };
                        })}
                        showFilter={false}
                        showButtonToXlsx={false}
                    />
                </Box>
            </div>
        </TabPanel>
    );
}